import { createFileRoute } from "@tanstack/react-router";
import { options } from "@/pages/how-to-crop-a-gif";

export const Route = createFileRoute("/blog/how-to-crop-a-gif")(options);
